import { render, staticRenderFns } from "./ChatMassMessageModal.vue?vue&type=template&id=7b7088a1&scoped=true&"
import script from "./ChatMassMessageModal.vue?vue&type=script&lang=js&"
export * from "./ChatMassMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatMassMessageModal.vue?vue&type=style&index=0&id=7b7088a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7088a1",
  null
  
)

export default component.exports